import { createAction } from "@reduxjs/toolkit";

// Global action to reset the entire store state
export const resetStore = createAction("RESET_STORE");
